import { render, staticRenderFns } from "./UserDetailsForm.vue?vue&type=template&id=657beb60&scoped=true"
import script from "./UserDetailsForm.vue?vue&type=script&lang=js"
export * from "./UserDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsForm.vue?vue&type=style&index=0&id=657beb60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657beb60",
  null
  
)

export default component.exports